import React, {Component} from 'react'
import PropTypes from 'prop-types'

import '../../styles/css/ProgressButton.css'


const propTypes = {
    backColor: PropTypes.string,
    progressColor: PropTypes.string,
    textColor: PropTypes.string,
    title: PropTypes.string.isRequired,
    progress: PropTypes.number,
}

const defaultProps = {
    backColor: '#000',
    progressColor: '#cc172c',
    textColor: 'white',
}


class ProgressButton extends Component {
    constructor(props) {
        super(props)

        this.state = {
        }
    }

    componentDidMount() {

    }

    render() {
      // let container = document.getElementById('progress-button-container')
      // var progressWidth = '100'
      var answersizeVertical = '40px'
      var answersizeHorizontal = '40px'
      if(this.props.variables.answersizeVertical && this.props.variables.answersizeVertical.trim().length > 0){
        answersizeVertical = this.props.variables.answersizeVertical + "px"
      }
      if(this.props.variables.answersizeHorizontal && this.props.variables.answersizeHorizontal.trim().length > 0){
        answersizeHorizontal = this.props.variables.answersizeHorizontal + "px"
      }

      // if(container){
      //     progressWidth = parseInt(container.clientWidth * this.props.progress / 100, 10)
      // }

        return (
            <div className="progress-button-container" id="progress-button-container" style={{
              backgroundColor: this.props.correct ? this.props.variables.progressBarEndWinColor : this.props.variables.progressBarBackgroundColor
            }}>
                <div className="progress-container" style={{
                    backgroundColor: this.props.variables.progressBarColor,
                    // width: progressWidth,
                }} />

                <div className="progress-title-container" style={{display: 'block', alignItems: 'center'}}>
                    <p className="progress-title" style={{ color: this.props.variables.progressBarTextColor, fontSize: this.props.from ? answersizeVertical : answersizeHorizontal }}>{this.props.title}</p>
                  {/*  <p className="progress-value" style={{ color: this.props.variables.progressBarTextColor }}>{parseInt(this.props.progress, 10)}%</p>*/}
                </div>
            </div>
        )
    }
}

ProgressButton.propTypes = propTypes
ProgressButton.defaultProps = defaultProps

export default ProgressButton



// WEBPACK FOOTER //
// ./src/components/utils/ProgressButton.js